import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 50%',
        maxWidth: '50%',
        '& .hero-shaped__image': {
          width: '50vw',
        },
      },
    },
    '& .MuiButton-containedPrimary': {
      backgroundColor: `${palette.primary.main} !important`,
      color: `${palette.text.highlight} !important`,
      '&:hover': {
        backgroundColor: `${palette.primary.main} !important`,
        opacity: 0.9,
      },
    },
    '& .MuiButton-textPrimary, & .MuiButton-text': {
      color: `${palette.primary.main} !important`,
      '&:hover': {
        backgroundColor: 'rgba(54, 92, 125, 0.04)',
        color: `${palette.primary.main} !important`,
      },
    },
    '& .MuiButton-outlinedPrimary': {
      borderColor: `${palette.primary.main} !important`,
      color: `${palette.primary.main} !important`,
      '&:hover': {
        borderColor: `${palette.secondary.main} !important`,
        backgroundColor: 'rgba(54, 92, 125, 0.04)',
        color: `${palette.primary.main} !important`,
      },
    },
    '& .MuiLink-root': {
      color: `${palette.secondary.main} !important`,
      '&:hover': {
        color: `${palette.secondary.main} !important`,
      },
    },
    '& .MuiTypography-colorPrimary': {
      color: `${palette.primary.main} !important`,
    },
    '& .MuiRadio-root': {
      color: `${palette.primary.main} !important`,
      '&.Mui-checked': {
        color: `${palette.secondary.main} !important`,
      },
      '& .MuiSvgIcon-root': {
        color: 'inherit',
      },
    },
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.secondary.main,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${palette.secondary.main} !important`,
        borderWidth: '1px',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.secondary.main,
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .menu-item, .header-phone-link': {
      fontSize: '16px !important',
    },
    '& .topbar-listitem': {
      padding: '0px 10px !important',
    },
    '& .MuiToolbar-root': {
      minHeight: '72px',
      /* Same 1280px content column as the page sections, so the logo and nav
         line up with the cards, how-it-works block and FAQ banner. */
      width: '100%',
      maxWidth: '1280px',
      margin: '0 auto',
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
  },

  '.group-parent-container': {
    '& .normal-text': {
      fontWeight: '700 !important',
      fontFamily: 'The Seasons !important',
      fontSize: '52px !important',
      lineHeight: '120% !important',
      letterSpacing: '0.04em !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '0.04em !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '0.04em !important',
      },
    },
    /* Hero's own styles set fontSize 13, width 100% and their own padding;
       Figma wants auto-width 51px pills with 16px labels. */
    '& .hero-link-button': {
      width: 'auto !important',
      minWidth: '0 !important',
      padding: '14px 32px !important',
      fontSize: '16px !important',
      lineHeight: '24px !important',
    },
    '& .hero-home-button': {
      backgroundColor: palette.text.highlight,
      color: palette.primary.main,
      borderColor: palette.primary.main,
      width: 'auto !important',
      minWidth: '0 !important',
      padding: '13px 31px !important',
      fontSize: '16px !important',
      lineHeight: '24px !important',

      '&:hover': {
        backgroundColor: palette.text.highlight,
        borderColor: palette.primary.main,
      },
    },

    '& .faq-contact-section': {
      background: `${palette.primary.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        paddingInline: '20px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 600px) ': {
        paddingInline: '20px !important',
      },
      '& .contact-card-title': {
        fontFamily: 'The Seasons !important',
        fontWeight: '700 !important',
        fontSize: '56px !important',
        lineHeight: '120% !important',
        letterSpacing: '0.04em !important',
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          letterSpacing: '0.04em !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          letterSpacing: '0.04em !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.primary,
        fontSize: '16px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.32px !important',
        maxWidth: 'unset',
        '@media(max-width: 900px)': {
          fontSize: '22px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.66px !important',
        },
      },
      '& .contact-img-wrapper': {
        padding: '0px !important',
        marginRight: '26px !important',
        width: '60px !important',
        maxWidth: '60px !important',
        flexBasis: 'auto !important',
        '& img, & .image': {
          width: '60px !important',
          height: '60px !important',
        },
      },
      /* Design stacks the three details in a single centred column on a
         white container; the dividers between them are dropped. */
      '& .contact-items-row': {
        flexDirection: 'column !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        /* Each row is the same width and centred, so all three chips line up
           on one left edge (Figma centres the block, not each row). */
        '& > .MuiGrid-item': {
          width: 'min(400px, 100%)',
          maxWidth: 'min(400px, 100%)',
          flexBasis: 'auto !important',
          margin: '0 auto !important',
          paddingTop: '0 !important',
          paddingBottom: '0 !important',
        },
        background: `${palette.text.highlight} !important`,
        borderRadius: '30px',
        width: '100% !important',
        maxWidth: '800px',
        margin: '0 auto !important',
        padding: '48px 40px !important',
        rowGap: '30px',
        '@media(max-width: 600px)': {
          padding: '32px 20px !important',
          rowGap: '24px',
        },
        '& hr': {
          display: 'none !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'Basis Grotesque Pro !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.32px !important',
        color: palette.text.primary,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 28,
        lineHeight: '32px !important',
        letterSpacing: '-0.56px !important',
        fontFamily: 'Basis Grotesque Pro !important',
        fontWeight: 700,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 88,
      background: `${palette.background.dark} !important`,
      '& .hero-header-title': {
        fontFamily: 'The Seasons !important',
        fontSize: '56px !important',
        lineHeight: '120% !important',
        letterSpacing: '0.04em !important',
        fontWeight: '700 !important',
        color: `${palette.text.primary} !important`,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Basis Grotesque Pro !important',
        fontSize: '16px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
        color: `${palette.text.primary} !important`,
      },
      '@media screen and (max-width: 900px)': {
        '& .hero-header-title': {
          fontSize: '32px !important',
        },
        '& .hero-header-subtitle': {
          fontSize: '15px !important',
        },
      },

      '& .hero-home-button': {
        backgroundColor: 'transparent',
        color: palette.text.primary,
        borderColor: palette.primary.main,
        '&:hover': {
          backgroundColor: 'transparent',
          borderColor: palette.primary.main,
          color: palette.text.primary,
        },
      },

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.primary,
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
      '& .success-wrapper': {
        '& .MuiButton-containedPrimary': {
          backgroundColor: palette.text.highlight,
          color: palette.text.primary,
          border: `1px solid ${palette.primary.main}`,
        },
      },
    },

    '& .topbar-listitem': {
      '& .MuiButtonBase-root': {
        textTransform: 'none',
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      marginTop: 80,
      background: palette.surface.planCard,
      '@media(max-width: 600px)': {
        paddingBottom: 40,
      },
      '& .hero-left-section': {
        paddingInline: 0,
      },

      '& .hero-section-alternate': {
        '& .section-alternate__content': {
          '@media(max-width: 1024px) and (min-width: 900px)': {
            paddingTop: 56,
            paddingBottom: 56,
          },
          '@media(max-width: 900px) and (min-width: 600px)': {
            paddingInline: 0,
            paddingBottom: 20,
          },
          '@media(max-width: 600px)': {
            paddingInline: 20,
            paddingBottom: 0,
          },
          '& .hero-left-section': {
            '@media(max-width: 900px) and (min-width: 600px)': {
              paddingInline: 80,
              paddingBottom: 50,
            },
          },
        },
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title': {
          maxWidth: 600,
          lineHeight: '120% !important',
          letterSpacing: '0.04em !important',
          fontSize: '52px !important',
          /* MuiTypography-h2 also sets a weight, so this needs !important */
          fontWeight: '700 !important',
          '@media(max-width: 1024px) and (min-width: 600px)': {
            fontSize: '56px !important',
            lineHeight: '56px !important',
            letterSpacing: '0.04em !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '48px !important',
            letterSpacing: '0.04em !important',
          },
          '@media(max-width: 900px)': {
            textAlign: 'center',
            maxWidth: '100% !important',
          },

          '@media(min-width: 900px)': {
            lineHeight: '62px',
          },

          '& .hero-tagline': {
            fontSize: '36px !important',
            lineHeight: '40px !important',
            letterSpacing: '0.04em !important',
            color: `${palette.secondary.main} !important`,
            fontWeight: '500 !important',
            paddingBottom: '30px !important',
            '@media(max-width: 600px)': {
              fontSize: '24px !important',
            },
          },

          '& .header-text': {
            fontSize: '64px !important',
            lineHeight: '72px !important',
            letterSpacing: '0.04em !important',
            color: `${palette.text.primary} !important`,
            fontWeight: '500 !important',
            display: 'block',
            '@media(max-width: 600px)': {
              fontSize: '40px !important',
              lineHeight: '44px !important',
            },
          },
        },
        '& .section-header': {
          '@media(max-width: 900px)': {
            display: 'flex',
            justifyContent: 'center',
          },
        },
        '& .section-header__subtitle-wrapper': {
          '@media(max-width: 900px)': {
            display: 'flex',
            justifyContent: 'center',
          },
        },
        '& .section-header__cta-wrapper': {
          '@media(max-width: 900px) and (min-width: 600px)': {
            maxWidth: '100% !important',
            flexBasis: '80% !important',
          },
          '@media(max-width: 600px)': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
          },
          '& .section-header__cta-container': {
            '@media(max-width: 900px)': {
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
            },
            '& .section-header__cta-item-wrapper': {
              '@media(max-width: 900px)': {
                width: 'auto !important',
              },
              '& .primary-button, & .secondary-button': {
                '@media(max-width: 900px)': {
                  width: 'auto !important',
                },
              },
              '& .secondary-button': {
                borderColor: palette.secondary.main,
                color: `${palette.secondary.main} !important`,
                '&:hover': {
                  borderColor: palette.secondary.main,
                  backgroundColor: 'rgba(54, 92, 125, 0.04)',
                  color: `${palette.secondary.main} !important`,
                },
                '@media(max-width: 900px)': {
                  marginLeft: '16px !important',
                  marginTop: '16px !important',
                },
              },
            },
          },
        },
        '& .hero-subtitle': {
          paddingTop: 20,
          maxWidth: 560,
          fontSize: 16,
          lineHeight: '22px',
          letterSpacing: '-0.32px',
          color: palette.text.primary,
          '@media(max-width: 900px)': {
            textAlign: 'center',
          },
          '@media(min-width: 600px) and (max-width: 1024px)': {
            fontSize: '18px !important',
            letterSpacing: '-0.6px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '18px !important',
            letterSpacing: '-0.4px !important',
          },
        },
      },
      '& .image-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        '@media(min-width: 900px) and (max-width: 1024px)': {
          padding: 0,
          height: '100% !important',
        },
        '@media(max-width: 900px)': {
          padding: 0,
          width: '100% !important',
          maxWidth: '100% !important',
        },
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
          borderRadius: '16px',
          '@media(max-width: 900px) and (min-width: 600px)': {
            paddingBottom: '20px !important',
            paddingTop: '20px !important',
          },
          '@media(max-width: 600px)': {
            padding: 20,
          },
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.surface.planCard,
      '& .definition-variant-2': {
        padding: '96px 80px !important',
        '@media(max-width: 1200px)': {
          padding: '64px 48px !important',
        },
        '@media(max-width: 900px)': {
          padding: '48px 16px !important',
        },
      },
      '& .section-alternate__content': {
        padding: '0 !important',
        maxWidth: '1280px',
        margin: '0 auto',
      },
      '& .benefits-wrapper': {
        padding: 0,
      },
      '& .section-header': {
        marginBottom: 0,
      },
      '& .section-header__subtitle-wrapper': {
        display: 'none',
      },
      '& .section-header__title': {
        fontWeight: 700,
        whiteSpace: 'normal',
        fontFamily: 'The Seasons !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '0.04em !important',
        paddingBottom: '0 !important',
        textAlign: 'center !important',
        color: palette.text.primary,
        '@media(max-width: 900px)': {
          fontSize: '40px !important',
          lineHeight: '48px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '40px !important',
          letterSpacing: '0.04em !important',
        },
      },
      '& .definition-benefits-grid': {
        marginTop: '56px !important',
        width: 'calc(100% + 40px) !important',
        marginLeft: '-20px !important',
        marginRight: '-20px !important',
        justifyContent: 'flex-start',
        '& > .MuiGrid-item': {
          padding: '20px !important',
        },
        '@media(max-width: 600px)': {
          marginTop: '28px !important',
        },
      },
      '& .definition-service-tile': {
        maxWidth: 'none !important',
        padding: '0 !important',
        /* The grid line stretches this item, so leave its height auto: a
           percentage height here resolves against an auto-height container
           and collapses back to content height, which is what left the cards
           in a row at different heights. The card fills it with flex below. */
        display: 'flex',
        alignItems: 'stretch',
        '& .definition-service-innertile': {
          background: palette.text.highlight,
          borderRadius: '30px',
          padding: '40px !important',
          flex: 1,
          flexDirection: 'column !important',
          /* MUI's Grid container wraps by default; with a stretched (definite)
             height that wraps the icon/title/copy into side-by-side columns. */
          flexWrap: 'nowrap !important',
          /* xs={12} puts flex-basis:100% on each child, which in a column
             container is a *height* basis: the title and copy then share the
             card height by shrink factor, so the first copy line landed at a
             different offset per card. Size them by content and stack. */
          '& > .MuiGrid-item': {
            flexBasis: 'auto !important',
            flexGrow: 0,
            flexShrink: 0,
            width: '100%',
            maxWidth: '100% !important',
          },
          alignItems: 'flex-start !important',
          justifyContent: 'flex-start !important',
          margin: '0 !important',
        },
      },
      '& .customIcon': {
        justifyContent: 'flex-start !important',
        paddingBottom: '24px !important',
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
        /* Figma's Icon frames: a 64x90 Light Aqua pill with the glyph inside,
           so no CSS chip is needed here. */
        '& img, & .image': {
          width: '64px !important',
          height: '90px !important',
        },
      },
      '& .definition-service-title': {
        fontWeight: 500,
        color: palette.text.primary,
        fontFamily: 'Basis Grotesque Pro !important',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        textAlign: 'left !important',
        paddingBottom: '16px !important',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontFamily: 'Basis Grotesque Pro !important',
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: palette.text.primary,
        textAlign: 'left !important',
        letterSpacing: '-0.64px !important',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      position: 'relative',
      background: palette.surface.pricing,
      padding: '0 !important',
      '& .subscription-bg': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100% !important',
        background: palette.surface.pricing,
        zIndex: 0,
      },
      '& .desc-box': {
        display: 'block',
        marginTop: '20px',
        marginBottom: 0,
        maxWidth: '100%',
        '& .savings-link': {
          marginTop: 0,
          marginBottom: 0,
          fontWeight: 400,
          fontFamily: 'Basis Grotesque Pro !important',
          fontSize: '16px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.32px !important',
          color: `${palette.primary.contrastText} !important`,
          '@media(max-width: 600px)': {
            fontSize: '18px !important',
            lineHeight: '24px !important',
          },
        },
      },
      '& .subscription-section': {
        minHeight: 'auto !important',
        padding: '96px 80px',
        '@media(max-width: 1200px)': {
          padding: '64px 48px',
        },
        '@media(max-width: 900px)': {
          padding: '48px 16px',
        },
      },
      '& #pricing-benefit-section': {
        position: 'relative',
        zIndex: 1,
        '& .subscription-section-container': {
          alignItems: 'center',
          '@media(min-width: 900px)': {
            '& > .left-section': {
              paddingRight: '48px !important',
            },
            '& > .right-section': {
              paddingLeft: '48px !important',
            },
          },
          '& .left-section': {
            justifyContent: 'center',
            '& .title-box': {
              marginTop: 0,
              marginBottom: 0,
              '& .section-header': {
                textAlign: 'left',
                margin: 0,
              },
              '& .section-header__title': {
                fontWeight: '700 !important',
                fontFamily: 'The Seasons !important',
                fontSize: '52px !important',
                lineHeight: '120% !important',
                letterSpacing: '0.04em !important',
                color: `${palette.primary.contrastText} !important`,
                whiteSpace: 'pre-line',
                '@media(max-width: 600px)': {
                  fontSize: '44px !important',
                  lineHeight: '48px !important',
                  letterSpacing: '0.04em !important',
                },
              },
              /* Hide API plan_summary_desc; copy comes from subscriptions.offer_text2 in desc-box */
              '& .section-header__subtitle-wrapper': {
                display: 'none !important',
              },
            },
            '& .getstarted-button-container': {
              paddingTop: '40px',
              paddingBottom: 0,
              '@media(max-width: 900px)': {
                display: 'flex',
                justifyContent: 'center',
              },
            },
            '& .getstarted-button-desktop': {
              borderRadius: '9999px !important',
              backgroundColor: `${palette.primary.main} !important`,
              color: `${palette.primary.contrastText} !important`,
              height: 'auto',
              width: 'auto',
              minWidth: 0,
              padding: '12px 32px',
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontFamily: 'Basis Grotesque Pro !important',
              fontWeight: 400,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: `${palette.primary.main} !important`,
                opacity: 0.9,
              },
            },
            '& .description-section': {
              backgroundColor: 'transparent',
              width: '100%',
              marginTop: '56px',
              '@media(max-width: 900px)': {
                marginTop: '32px',
              },
            },
            '& .review-box': {
              paddingTop: '32px',
              /* V2 maps subscriptions.review → .rating, subscriptions.rating → .review */
              '& .rating': {
                display: 'none',
              },
              '& .review': {
                fontSize: '16px !important',
                lineHeight: '22px !important',
                letterSpacing: '-0.32px !important',
                fontFamily: 'Basis Grotesque Pro !important',
                fontWeight: 400,
                color: `${palette.primary.contrastText} !important`,
                paddingTop: 0,
                marginBottom: 0,
                '@media(max-width: 900px)': {
                  textAlign: 'center',
                },
              },
            },
            '& .savings-summary-link': {
              color: `${palette.primary.contrastText} !important`,
              textDecoration: 'underline',
              cursor: 'pointer',
            },
            '@media(max-width: 900px)': {
              '& .section-header, & .section-header__title': {
                textAlign: 'center !important',
              },
              '& .desc-box .savings-link': {
                textAlign: 'center',
              },
            },
          },
          '& .right-section': {
            justifyContent: 'center',
            '& .section': {
              padding: 0,
              width: '100%',
              maxWidth: 480,
            },
            '& .planCard': {
              width: '100% !important',
              maxWidth: 480,
              /* Figma: Alabaster card so the white price band reads against it */
              background: `${palette.surface.planCard} !important`,
              borderRadius: '30px !important',
              border: 'none !important',
              boxShadow: 'none',
              '&:hover': {
                background: `${palette.surface.planCard} !important`,
                color: palette.text.primary,
              },
              '& .customCardContent': {
                padding: '40px 20px !important',
              },
              '& .planCardHeaderContainer': {
                justifyContent: 'flex-start !important',
                alignItems: 'center !important',
                flexWrap: 'nowrap !important',
              },
              /* capsule mark before the plan name: 55x90, 20px gap */
              '& .customPlanPreIcon': {
                width: '55px !important',
                height: '90px !important',
                objectFit: 'contain',
                marginRight: '20px !important',
              },
              '& .customcardTitle': {
                fontWeight: '700 !important',
                fontFamily: 'Basis Grotesque Pro !important',
                fontSize: '28px !important',
                lineHeight: '32px !important',
                letterSpacing: '-0.56px !important',
                color: palette.text.primary,
                textAlign: 'left',
              },
              '& .price-item': {
                backgroundColor: palette.text.highlight,
                borderRadius: '8px !important',
                padding: '20px 72px !important',
                textAlign: 'center',
                marginBottom: '32px !important',
                '@media(max-width: 600px)': {
                  padding: '20px 24px !important',
                },
              },
              '& .price-value': {
                fontWeight: '700 !important',
                fontSize: '56px !important',
                fontFamily: 'Basis Grotesque Pro !important',
                lineHeight: '60px !important',
                letterSpacing: '-1.12px !important',
                color: palette.text.primary,
              },
              '& .price-frequency, & .display-frequency': {
                fontSize: '20px !important',
                lineHeight: '26px !important',
                letterSpacing: '-0.4px !important',
                color: `${palette.text.secondary} !important`,
              },
              '& .customSubscriberName': {
                fontSize: '16px !important',
                lineHeight: '22px !important',
                letterSpacing: '-0.32px !important',
                color: `${palette.text.secondary} !important`,
                textAlign: 'center',
              },
              '& .bold': {
                fontWeight: '700 !important',
                fontSize: '24px !important',
                lineHeight: '28px !important',
                letterSpacing: '-0.48px !important',
                fontFamily: 'Basis Grotesque Pro !important',
                color: `${palette.text.primary} !important`,
              },
              '& .cptCodes': {
                fontSize: '16px !important',
                lineHeight: '22px !important',
                letterSpacing: '-0.32px !important',
                color: palette.text.primary,
              },
              '& .yesIcon, & .MuiAvatar-root': {
                width: '20px !important',
                height: '20px !important',
              },
              '& .customButtonWrapper, & .cardDivider': {
                display: 'none !important',
              },
              '& .customBenefitsContainer': {
                minHeight: '0 !important',
                marginBottom: '0 !important',
              },
              '& .customUpfrontWrapper': {
                color: palette.text.tertiaryLight,
                fontWeight: 400,
                lineHeight: '16px !important',
                letterSpacing: '-0.42px !important',
                fontStyle: 'italic',
              },
            },
            '& .plans-loader': {
              color: palette.text.primary,
            },
          },
        },
        '& .savings-summary-link': {
          color: `${palette.text.primary} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },
    
    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.fill,
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '40px !important',
        },
        '@media(min-width: 1024px)': {
          padding: '40px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '30px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'The Seasons !important',
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '0.04em !important',
          fontWeight: 700,
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '48px !important',
            letterSpacing: '0.04em !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '0.04em !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.4px !important',
          '@media(max-width: 900px)': {
            fontSize: '22px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        marginBottom: 40,
        '@media(max-width: 600px)': {
          marginBottom: 20,
          '& .section-header__title': {
            textAlign: 'center !important',
          },
        },
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(max-width: 1000px)': {
          paddingTop: '40px !important',
        },
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.brand,
        color: palette.text.highlight,
        fontSize: 15,
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '&:not(:last-child)': {
          borderBottom: `1px solid ${palette.background.border} !important`,
        },
        '& .step-title': {
          fontSize: 20,
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          fontFamily: 'Basis Grotesque Pro !important',
          paddingBottom: '8px !important',
        },
        '& .step-content': {
          fontSize: 16,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
          color: palette.text.primary,
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 18,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
          paddingRight: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.background.border} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.surface.planCard,
          color: palette.text.primary,
          fontWeight: 600,
        },
        /* Figma: Midnight Blue header row, white 16px labels */
        '& .MuiTableCell-head': {
          backgroundColor: `${palette.surface.pricing} !important`,
          color: `${palette.text.highlight} !important`,
          fontSize: '16px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.32px !important',
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.primary.main} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.secondary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      background: palette.text.highlight,
      padding: '0 80px 80px !important',
      position: 'relative',
      '@media(max-width: 1200px)': {
        padding: '0 48px 64px !important',
      },
      '@media(max-width: 900px)': {
        padding: '0 16px 48px !important',
      },
      '& .hero-static-bg': {
        display: 'none !important',
      },
      '& .section-alternate': {
        /* Same 1280px content column as the cards and how-it-works block,
           so the banner lines up with them instead of bleeding wider. */
        maxWidth: '1280px !important',
        margin: '0 auto !important',
        background: palette.background.hero1,
        borderRadius: '30px',
        overflow: 'hidden',
        height: 'auto !important',
        paddingInline: '0 !important',
        display: 'block',
        '& .section-alternate__content': {
          padding: '64px 80px !important',
          '@media(max-width: 900px)': {
            padding: '48px 32px !important',
          },
          '@media(max-width: 600px)': {
            padding: '40px 20px !important',
          },
        },
      },
      '& .section-header': {
        marginBottom: 0,
      },
      '& .section-header__title': {
        color: palette.primary.contrastText,
        fontWeight: 700,
        fontFamily: 'The Seasons !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '0.04em !important',
        paddingBottom: '12px !important',
        '@media(max-width: 900px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
          letterSpacing: '0.04em !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '28px !important',
          lineHeight: '32px !important',
        },
      },
      '& .section-header__subtitle': {
        color: palette.primary.contrastText,
        fontWeight: 400,
        fontFamily: 'Basis Grotesque Pro !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.54px !important',
        opacity: 0.8,
        '@media(max-width: 600px)': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
        },
      },
      '& .hero-button-wrapper': {
        '& .MuiButton-label': {
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          fontFamily: 'Basis Grotesque Pro !important',
          fontWeight: 400,
          textTransform: 'none',
        },
        '& .MuiButton-containedPrimary, & .primary-static-button': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.primary.contrastText} !important`,
          borderRadius: '9999px !important',
          padding: '12px 20px !important',
          boxShadow: 'none',
          minHeight: 'auto',
          '&:hover': {
            backgroundColor: `${palette.primary.main} !important`,
            opacity: 0.9,
          },
        },
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'flex-end !important',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'center !important',
          marginTop: '24px !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .checkout-innner-container': {
        '& .customDetailsContainer': {
          '& .MuiButtonBase-root': {
            textTransform: 'none !important',
          },
        },
      },
      '& .hero-header-title': {
        fontFamily: 'The Seasons !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '0.04em !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Basis Grotesque Pro !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.secondary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      background: `var(--background-dark, ${palette.background.dark}) !important`,
      /* Primary hero button is the black pill, same as every other hero;
         this used to force it white, which beat MuiButton-containedPrimary. */
      '& .MuiButton-contained': {
        backgroundColor: palette.primary.main,
        color: palette.primary.contrastText,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
      '& .hero-header-title': {
          fontSize: '32px !important',
        },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      /* Figma: card headings are a bold sans (32px left, 28px right) and the
         Current Total is Lake Blue — not the display serif / success green. */
      '& .customDetailsContainer .section-header__title': {
        fontFamily: 'Basis Grotesque Pro !important',
        fontWeight: '700 !important',
        fontSize: '32px !important',
        lineHeight: '36px !important',
        letterSpacing: '-0.64px !important',
      },
      '& .summary-content-root .section-header__title': {
        fontFamily: 'Basis Grotesque Pro !important',
        fontWeight: '700 !important',
        fontSize: '28px !important',
        lineHeight: '32px !important',
        letterSpacing: '-0.56px !important',
      },
      '& .summary-content-root .MuiTypography-h6': {
        fontFamily: 'Basis Grotesque Pro !important',
        fontWeight: '700 !important',
        fontSize: '22px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.44px !important',
      },
      '& .summary-content-root label.MuiTypography-h5': {
        color: `${palette.background.hero1} !important`,
        fontFamily: 'Basis Grotesque Pro !important',
        fontWeight: '700 !important',
        fontSize: '32px !important',
        lineHeight: '36px !important',
        letterSpacing: '-0.64px !important',
      },
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'The Seasons',
        fontWeight: 500,
        letterSpacing: '0.04em',
      },
    },
    '& .customAddMembersLink': {
      color: palette.text.secondary,
    },
    '& .customPromoToggle': {
      color: palette.text.secondary,
    },
    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.primary.light,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.text.brand,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.text.brand} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.text.brand} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.brand  , // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },


    /* Above 1440px the padding-based sections keep widening while the cards,
       banner and header sit on a fixed 1280px column. Cap them so every
       section shares one column, as in the Figma frame. */
    '@media(min-width: 1441px)': {
      '& .home-hero-wrapper .section-alternate__content, & .subscription-wrapper .subscription-section, & .howitworks-section .section': {
        maxWidth: '1280px !important',
        marginInline: 'auto !important',
        paddingInline: '0 !important',
      },
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      paddingInline: '40px !important',
      color: `${palette.text.primary} !important`,
      '& a': {
        color: `${palette.text.primary} !important`,
      },
      /* These carry an explicit light colour for dark footers */
      '& .footer-link, & .copyrights-footer, & .copyrights-footer-link': {
        color: `${palette.text.primary} !important`,
      },
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
    },

  },
};
